export enum LessonType {
  VIDEO = 'VIDEO',
  SLIDES = 'SLIDES',
  PRAC = 'PRAC',
  JEDDLE = 'JEDDLE',
}
